<template>
  <div class="mt-5 mx-3">
    <!-- <h1>{{ title }}</h1> -->
    <!-- <h1 class='headline ml-3 mt-4'>{{ title }}</h1> -->
    <!-- {{ this.filteredByOwnership.length }} -->
    <artworks-table
      :items="filteredByOwnership"
      v-on:switchOwnershipToAll="switchOwnershipToAll($event)"
      v-on:switchOwnershipTop="switchOwnershipTop($event)"
      @saveSearchValue="saveSearchValue($event)"
      @saveArtworkPageValue="saveArtworkPageValue($event)"
    >
    </artworks-table>
    <!-- <filter-box></filter-box> -->
    <!-- <artworks-box></artworks-box> -->
    <!-- <div class="btn-group btn-group-sm mx-auto" role="group" aria-label="Basic example">
    <v-btn @click="switchOwnership(ownership.id)" flat v-for="ownership in $store.state.ownerships" category="ownerships" v-bind:title="ownership.name" v-bind:key="ownership.id">{{ownership.name}}</v-btn>
  </div> -->

    <!-- filtering form -->
    <!-- <v-card color="grey lighten-4" flat>
    <v-card-text>
      <v-container fluid>
        <v-layout row wrap>           
          <v-flex xs4>
              <label for="filterText">Artist Name</label>
              <input id="filteredTextArtist" type="text" name="textfield" v-model="filteredTextArtist"></input>
          </v-flex xs4>
          <v-flex xs4>
              <label for="filterText">Artwork Title</label>
              <input id="filteredTextArtwork" type="text" name="textfield" v-model="filteredTextArtwork"></input>
          </v-flex xs4>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>           -->

    <!-- artists/artwork listing -->
    <!-- <v-layout row>
    <v-flex xs12 sm12>
        <v-list three-line>
          <div v-for="artist in displayedData" v-bind:key="artist.id">
            <h2 inset v-if="artist.name" v-text="artist.name"> </h2>
            <v-list-tile avatar v-for="artwork in artist.artworks" v-bind:key="artwork.id"> 
              <v-list-tile-avatar tile v-if="artwork.top_photo_id">
                <img v-bind:src="'http://tb-cms.org/data/artwork/' + artwork.id + '/' + artwork.top_photo_id + '_th.jpg'"/>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <router-link :to="`/artworks/view/${artwork.id}`">{{ artwork.title }}</router-link>
                </v-list-tile-title>
                <v-list-tile-sub-title>{{ artwork.accession_number }}</v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <div v-if="artwork.artwork_location" >{{ artwork.artwork_location.name }} - {{ artwork.classification }}</div>
                </v-list-tile-sub-title> -->
    <!-- <edit-artwork v-if="editArtwork" v-bind="artwork"></edit-artwork> -->
    <!-- </v-list-tile-content> -->
    <!-- <v-list-tile-action>
                <v-btn icon @click="$router.push({ path: `/artworks/view/${artwork.id}` })">
                  <v-icon color="grey lighten-1">remove_red_eye</v-icon>
                </v-btn>
              </v-list-tile-action> -->
    <!-- </v-list-tile> -->
    <!-- <v-divider inset></v-divider> -->
    <!-- </div> 
        </v-list>
    </v-flex>
  </v-layout> -->

    <!-- <table class="table">
    <thead>
      <tr>
        <th scope="col" class="">Title</th>
        <th scope="col" class="">Artist</th>
        <th scope="col" class="">Accession Number</th>
      </tr>
    </thead>
    <tbody v-if="processedArtworks.length">
      <tr is="artwork-item" 
          v-for="artwork in processedArtworks"
          v-bind:artwork="artwork"
          v-bind:key="artwork.id">
      </tr>
    </tbody>
    <tbody v-else-if="artworks.length" >
      <tr class="no-results">
          <h4>{{ noResults }} no results...</h4>
      </tr>
    </tbody>
    <tbody v-else class="no-results">
      <tr>
          <h4>Loading...</h4>
      </tr>
    </tbody>
    <tfoot>
      <tr><th>{{processedArtworks.length}} artworks. {{processedArtists.length}} artists.</th>
          <th>2 Approved</th>
          <th></th>
      </tr>
    </tfoot>
  </table>
  <edit-artwork v-if="editArtwork" v-bind="artwork"></edit-artwork> -->
  </div>
</template>

<script>
// import axios from '@/utils/apiClient'
import EditArtwork from '@/components/artworks/EditArtwork.vue'
import FilterBox from '@/components/artworks/FilterBox'
import ArtworksTable from '@/components/artworks/ArtworksTable'
// import ArtworkItem from '@/components/artworks/ArtworkItem.vue'
// import ArtworksBox from '@/components/artworks/ArtworksBox'
// import ExifBox from '@/components/artworks/ExifBox'

export default {
  props: ['ownership'],
  beforeRouteLeave(to, from, next) {
    // this.$store.commit('routeChange')
    this.$store.dispatch('setSearchString', {
      string: this.search,
      section: 'artworks',
    })
    next()
  },
  data: function () {
    return {
      currentOwnership: 'all',
      ownershipToAll: false,
      displayedData: [],
      filteredTextArtwork: '',
      filteredTextArtist: '',
      selectedFilter: '',
      artwork: {
        name: '',
      },
      artists: [],
      artworks: [],
      resultsArtworks: [],
      resultsArtists: [],
      editArtwork: false,
      filterText: '',
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   if (to.params.ownership) {
  //     next((vm) => vm.switchOwnership(to))
  //   }
  //   if (to.params.work_type) {
  //     next((vm) => vm.filterArtworks(to))
  //   }
  // },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  // beforeRouteUpdate(to, from, next) {
  //   this.displayedData = []
  //   // getPost(to.params.id, (err, post) => {
  //   this.switchOwnership(to)
  //   if (to.params.work_type) {
  //     this.filterArtworks(to)
  //   }
  //   next()
  //   // })
  // },
  created: function () {
    //   // this.displayedData = this.$store.state.artworks
    this.$store.dispatch('loadArtworks')
    //   this.switchOwnership()
    //   // this.getArtworks(),
    //   // this.getArtists()

    //   //  this.switchOwnership(to)
    //   // {
    //     //   switch (router.currentRoute) {
    //     //     case 'collection':
    //     //     this.displayedData = this.$store.state.collection
    //     //     break
    //     //     case '6':
    //     //     this.displayedData = this.$store.state.pac_fvh
    //     //     break
    //     //     case '7':
    //     //     this.displayedData = this.$store.state.pdc_fvh
    //     //     break
    //     //     case '10':
    //     //     this.displayedData = this.$store.state.pac_mr
    //     //     break
    //     //     case '9':
    //     //     this.displayedData = this.$store.state.oldMasters
    //     //     break
    //     //     case 'deaccession':
    //     //     this.displayedData = this.$store.state.deaccession
    //     //     break
    //     //     default:
    //     //     this.displayedData = this.$store.state.collection
    //     //   }
    //   // },
  },
  methods: {
    saveSearchValue(s) {
      this.search = s
    },
    saveArtworkPageValue(p) {
      this.page = p
    },

    // filter: function(name) {
    //   this.filterText = name;
    // },
    // _toggle () {
    //   this.editArtwork = true
    // },
    // getArtworks () {
    //   let url = 'http://localhost:3000/artworks.json'
    //   axios.get(url).then((response) => {
    //     // this.loading = false;
    //     this.resultsArtworks = response.data
    //   }).catch((error) => { console.log(error) })
    // },
    // filterArtworks(to) {
    //   var c = 0
    //   switch (to.params.work_type) {
    //     case 'paintings':
    //       c = 2
    //       break
    //     case 'drawings':
    //       c = 1
    //       break
    //     case 'photographs':
    //       c = 3
    //       break
    //     case 'videos':
    //       c = 7
    //       break
    //     case 'sound':
    //       c = 9
    //       break
    //     case 'objectsAndSculptures':
    //       c = 4
    //       break
    //     default:
    //       this.displayedData = this.$store.state.artworks
    //   }
    //   if (c > 0) {
    //     this.displayedData = this.$store.state.artworks.filter(function (a) {
    //       return a.type_of_work_id == c && a.deaccessioned != 1
    //     })
    //   } else {
    //   }
    // },
    switchOwnershipToAll(switchStatus) {
      console.log('switchOwnershipToAll')
      // console.log(switchStatus)
      this.ownershipToAll = true
      this.switchOwnership(this.$route)
      // this.ownershipToAll = !this.ownershipToAll
      // this.displayedData = this.$store.state.artworks.filter(function (a) {
      //   return a.deaccessioned != 1
      // })
    },
    switchOwnershipTop(switchStatus) {
      console.log('switchOwnershipTop')
      console.log(this.$route)
      this.ownershipToAll = false
      // this.ownershipToAll = !this.ownershipToAll
      // if (switchStatus) {
      // } else {
        this.switchOwnership(this.$route)
      // }
    },
    switchOwnership(to = this.$route) {
      if (!to) {
        to = this.$route
      }
      // this.displayedData = this.$store.state.collection
      // console.log('switchOwnership')
      // console.log(this.displayedData)
      let to2 = ''
      if (to.params.ownership) {
        to2 = to.params.ownership
      } else {
        to2 = this.$route.params.ownership
      }
      this.currentOwnership = to2

      // switch (to2) {
      //   case 'all':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.deaccessioned != 1
      //       // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10))')
      //     })
      //     break
      //   case 'collection':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return (
      //         // ![6, 7, 8, 9, 10, 11, 12, 15, 17].includes(a.ownership) &&
      //         a.ownership == 1 && a.deaccessioned != 1
      //         // a.acquired != 'nontba' &&
      //         // a.acquired != 'commission'
      //       )
      //       // artworks.enable=1 and (loaned_artwork is null or loaned_artwork=0) and
      //       // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10 and ownership<>11))')
      //     })
      //     break
      //   case 'pacEh':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 17 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'pacFvh':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 6 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'pdcFvh':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 7 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'pacMr':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 10 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'pcFT':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 19 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'oldMasters':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 9 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'deaccession':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.deaccessioned == 1
      //     })
      //     break
      //   case 'gemini':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 12 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'geminiCL':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 15 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'geminiCD':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 16
      //     })
      //     break
      //   case 'pcCA':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 11 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'commissions':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return (
      //         a.acquired == 'commission' ||
      //         (a.acquired == 'acquired' &&
      //           a.acquisition_method == 3 &&
      //           a.deaccessioned != 1)
      //       )
      //       // (a.acquisition_method == 6 || a.acquisition_method == 3)
      //     })
      //     break
      //   case 'com_academy':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return (
      //         a.acquired == 'com_academy' &&
      //           a.deaccessioned != 1
      //       )
      //       // (a.acquisition_method == 6 || a.acquisition_method == 3)
      //     })
      //     break
      //   case 'nonTba':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return (
      //         a.deaccessioned != 1 &&
      //         (a.acquired == 'nontba' || a.loaned_artwork == 1)
      //       )
      //     })
      //     break
      //   default:
      //     this.displayedData = []
      // }
      // console.log(this.displayedData)
      // console.log('switchOwnership')
    },
    // getArtists () {
    //   if (this.$store.state.collection) {
    //     this.displayedData = this.$store.state.collection
    //   } else {
    //     let url = 'http://localhost:3000/artists.json?o=1'
    //     axios.get(url).then((response) => {
    //       // this.loading = false;
    //       this.resultsArtists = response.data
    //       this.$store.dispatch('saveArtists', response.data)
    //       this.displayedData = response.data

    //     }).catch((error) => { console.log(error) })
    //   }
    // },
    artworkPassesOwnershipFilter(artwork) {
      if (!this.ownership.length) {
        return true
      } else {
        let artworkOwnerships = artwork.ownership.split(', ')
        let matched = true
        this.ownership.forEach((ownership) => {
          if (artworkOwnerships.indexOf(ownership) === -1) {
            matched = false
          }
        })
        return matched
      }
    },
  },
  computed: {
    filteredByOwnership() {
      var filteredByOwnership = []
      var to = this.$route
      console.log('filteredByOwnership ---------------')
      console.log('to.params.ownership')
      console.log(to.params.ownership)
      console.log('this.ownershipToAll')
      console.log(this.ownershipToAll)
      console.log(this.currentOwnership)
      
      // let to2 = ''
      // if (to.params.ownership) {
      //   to2 = to.params.ownership
      // } else {
      //   to2 = this.$route.params.ownership
      // }
      // console.log('to2')
      // console.log(to2)

      if (this.ownershipToAll) {
        return filteredByOwnership = this.$store.state.artworks
      } else {

        filteredByOwnership = this.$store.state.artworks.filter((a) => {
          switch (to.params.ownership) {
          // switch (this.currentOwnership) {
            case 'all': return a.deaccessioned != 1
            // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10))')

            case 'collection': return a.ownership == 1 && a.deaccessioned != 1
            // ![6, 7, 8, 9, 10, 11, 12, 15, 17].includes(a.ownership) &&
            // a.acquired != 'nontba' &&
            // a.acquired != 'commission'
            // artworks.enable=1 and (loaned_artwork is null or loaned_artwork=0) and
            // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10 and ownership<>11))')
            case 'pacEh': return a.ownership == 17 && a.deaccessioned != 1
            case 'pacFvh': return a.ownership == 6 && a.deaccessioned != 1
            case 'pdcFvh': return a.ownership == 7 && a.deaccessioned != 1
            case 'pacMr': return a.ownership == 10 && a.deaccessioned != 1
            case 'pcFT': return a.ownership == 19 && a.deaccessioned != 1
            case 'pacGh': return a.ownership == 20 && a.deaccessioned != 1
            case 'pacFh': return a.ownership == 21 && a.deaccessioned != 1
            case 'oldMasters': return a.ownership == 9 && a.deaccessioned != 1
            case 'deaccession': return a.deaccessioned == 1
            case 'gemini': return a.ownership == 12 && a.deaccessioned != 1
            case 'geminiCL': return a.ownership == 15 && a.deaccessioned != 1
            case 'geminiCD': return a.ownership == 16
            case 'pcCA': return a.ownership == 11 && a.deaccessioned != 1
            case 'com_academy': return (a.acquired == 'com_academy' && a.deaccessioned != 1)
            case 'commissions': return (
              a.acquired == 'commission' || a.acquired == 'com_academy' ||
              (a.acquired == 'acquired' &&
                a.acquisition_method == 3 &&
                a.deaccessioned != 1)
            )
            // (a.acquisition_method == 6 || a.acquisition_method == 3)
            case 'nonTba': return (
              a.deaccessioned != 1 &&
              (a.acquired == 'nontba' || a.loaned_artwork == 1)
            )
            default: return a.deaccessioned != 1
          }
        })
        console.log('filteredByOwnership22')
        console.log(filteredByOwnership.length)
      }

      var to = this.$route

      if (to.params.work_type) {

        var c = 0
        switch (to.params.work_type) {
          case 'paintings':
            c = 2
            break
          case 'drawings':
            c = 1
            break
          case 'photographs':
            c = 3
            break
          case 'videos':
            c = 7
            break
          case 'sound':
            c = 9
            break
          case 'objectsAndSculptures':
            c = 4
            break
          default: this.$store.state.artworks
        }
        if (c > 0) {
          var out = filteredByOwnership.filter(function (a) {
            return a.type_of_work_id == c && a.deaccessioned != 1
          })
        } else {
        }
        return out
      } else {
        return filteredByOwnership
      }
    },
    // artworks_d() {
    //   // console.log('artworks_d')
    //   // return
    //   if (this.displayedData.length == 0) {
    //     this.displayedData = this.$store.state.artworks
    //     this.switchOwnership(this.$route)
    //     return this.displayedData
    //   } else {
    //     return this.displayedData
    //   }
    // },
    filtered() {
      return this.$store.state.filterResults
    },
    columns() {
      return this.$store.state.artworkColumns
    },
    processedArtists() {
      let artists = this.resultsArtists
      this.artists.map((artist) => {
        let a = artist
        artist.first_name = a ? a.first_name : 'nema meno'
      })
      return artists
    },
    // storedData() {
    //   let sdata = ''
    //   if (this.$store.state.filterResults) {
    //     sdata = this.$store.state.filterResults
    //   } else {
    //     sdata = this.filteredData
    //     this.$store.dispatch('postFilterResults', sdata)
    //   }
    //   this.displayedData = sdata
    //   return sdata
    // },
    filteredData() {
      let searchString = this.filteredTextArtwork

      if (this.filteredTextArtwork != '') {
        // vráť z "this.processedArtists" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "this.processedArtists"
        return this.processedArtists.filter(function (artist) {
          // vráť z "artist.artworks" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "artist.artworks" v premennej "q"
          return (
            artist.artworks.filter(function (artwork) {
              // vráť (čítať odzadu) true - ak "title" atribút obsahuje "search" string
              return (
                artwork.title
                  .toLowerCase()
                  .indexOf(searchString.toLowerCase()) > -1
              )
            }).length > 0
          )
        })
      } else {
        return this.processedArtists
      }
    },
    filteredArtworks: function () {
      var self = this
      // return self.artworks.filter(function (artwork) {
      //   return artwork.ownership.indexOf(self.searchQuery) == -1
      // })
      // var self = this
      self.artworks.filter(function (artwork) {
        var searchRegex = new RegExp(4, 'i')
        return searchRegex.test(artwork.ownership)
      })
    },

  },
  filters: {
    capitalize: function (a) {
      if (!a) return ''
      a = a.toString()
      return a.charAt(0).toUpperCase() + a.slice(1)
    },
  },
  // ArtworkItem, ArtworksBox
  components: {
    EditArtwork,
    FilterBox,
    ArtworksTable,
  },
}
</script>


h2 {
  padding: 20px 0 0 20px;
  font-weight: 100px;
}
}
</style>

// filterArtworks (artworks) {
//   // return self.artworks.filter(function (artwork) {
//   //   return artwork.ownership.indexOf(self.searchQuery) == -1
//   // })
//   return artworks.filter(function(artwork) {
//     return artwork.ownership == 5
//   })
// },
// filterArtworks2 (ownership) {
//   this.displayedData = this.$store.state.artists
//   // return self.artworks.filter(function (artwork) {
//   //   return artwork.ownership.indexOf(self.searchQuery) == -1
//   // })
//   let artists = ''
//   artists = this.$store.state.artists.filter(function(artist)  {
//       return artist.artworks.filter(function(artwork) {
//         return artwork.ownership == ownership
//     }).length > 1
//   })
//   this.displayedData = artists
//   // artworks.filter(function (artwork) {
//     // var searchRegex = new RegExp('1', 'i')
//     // return searchRegex.test(artwork.ownership)
// },
// filterArtworks3 (ownership) {
//   // return self.artworks.filter(function (artwork) {
//   //   return artwork.ownership.indexOf(self.searchQuery) == -1
//   // })
//   for (artist in this.storedData) {
//     for (artwork in artist.artworks) {
//       if (artwork.ownership == ownership) {
//         this.storedData[artist].artworks[artwork].splice(1,1)
//       }
//     }
//   }
//   let artists = ''
//   artists = this.storedData.filter(function(artist)  {
//       return artist.artworks.filter(function(artwork) {
//         return artwork.ownership == ownership
//     }).length > 1
//   })
//   this.displayedData = artists
//   // artworks.filter(function (artwork) {
//     // var searchRegex = new RegExp('1', 'i')
//     // return searchRegex.test(artwork.ownership)
// }

// processedArtworks () {
  //   let artworks = this.resultsArtworks
  //   this.artworks.map(artwork => {
  //     let a = artwork
  //     artwork.first_name = a ? a.first_name : 'nema meno'
  //   })
  //   return artworks
  // },
  // filteredArtworks () {
  //   return this.artworks
  //     .filter(this.artworkPassesOwnershipFilter)
  // },

  // return this.processedArtists.filter(function(obj) {
  //   return obj.artworks.title(function(item){
  //     return item.indexOf('a') >= 0;
  //   });
  // });
  // function getResult(filterBy, objList) {
  //   return objList.hightlights.filter(function(obj) {
  //   return obj.queries.some(function(item){
  //     return item.indexOf(filterBy) >= 0;
  //   });
  // });
  // }
  //   const x = 'title',
  //     filter = new RegExp(this.filteredText, 'i')
  //   return this.processedArtists.filter(el => {
  //     if (el[x] !== undefined) { return el[x].match(filter) }
  //     else return true;
  //   })
  // }

  // title() {
    //   let title = ''
    //   if (this.$route.fullPath == '/artworks/oldMasters') {
    //     title = 'Old Masters'
    //   } else if (this.$route.fullPath == '/artworks/deaccession' ) {
    //     title = 'Deaccessioned'
    //   } else if (this.$route.fullPath == '/artworks/collection') {
    //     title = 'TBA21 Collection'
    //   } else if (this.$route.fullPath == '/artworks/pacFvh') {
    //     title = 'Private Art Collection FTB'
    //   } else if (this.$route.fullPath == '/artworks/pdcFvh') {
    //     title = 'Private Design Collection FTB'
    //   } else if (this.$route.fullPath == '/artworks/pacMr') {
    //     title = 'Private Art Collection MR'
    //   } else if (this.$route.fullPath == '/artworks/pacEh' || this.$route.fullPath == '/artworks/ownership/pacEh') {
    //     title = 'Private Collection EH'
    //   }
    //   return title
    // },



// WEBPACK FOOTER //
// src/components/artworks/Artworks.vue